import "./check-profile.scss";

import { useUserIdentityContext } from "@core/services/user-identity.context";
import CustomerCard from "@core/ui/customer-card/customer-card";
import {
  GetResponseRewardModel,
  RewardBalance,
} from "@factory/model/query-model-reward";
import { useQyGetGoogleCloudAssetPreview } from "@factory/query/google-cloud-storage.query";
import { useQyGetRewardBalance } from "@factory/query/reward.query";
import Scan from "@shared/ui/scan/scan";
import useScreenSize from "@shared/utility/screen-size";
import { isNil } from "lodash-es";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

 
export interface CheckProfileProps {}

export function CheckProfile() {
  // DECLARATIONS
  const { isMobileMode } = useScreenSize();
  const { mutate: viewAsset } = useQyGetGoogleCloudAssetPreview();
  const { getUserRole } = useUserIdentityContext();
  const { tenant } = getUserRole();
  const navigate = useNavigate();
  const [scan, setScan] = useState(false);
  const [cardAlias, setCardAlias] = useState("");
  const [avatar, setAvatar] = useState<string>("");

  // API DEFINITIONS
  const handleBalanceApiSuccess = (response: GetResponseRewardModel) => {
    const data = response as RewardBalance;
    if (data?.level_avatar) {
      viewAsset(data?.level_avatar, {
        onSuccess(data) {
          const assetDisplay = URL.createObjectURL(data);
          setAvatar(assetDisplay);
        },
      });
    }
  };
  const { data: balance } = useQyGetRewardBalance(
    cardAlias ?? "",
    tenant,
    !!cardAlias,
    handleBalanceApiSuccess
  );
  const balanceData = balance as RewardBalance;

  // LOCAL FUNCTIONS
  const handleSuccessScan = (value: string) => {
    setCardAlias(value);
  };
  const handleCloseScan = () => {
    setScan(false);
  };

  // LOCAL RENDERS
  const footerContent = (
    <div>
      <Button
        className="block w-full mt-2"
        label="Close"
        severity="secondary"
        outlined
        onClick={() => navigate("/business/campaign")}
      />
    </div>
  );

  return (
    <div id="CheckProfile" className="check-profile">
      <Dialog
        header="Check Profile"
        visible={true}
        style={{ width: "50vw" }}
        onHide={() => {
          navigate("/business/campaign");
        }}
        closeOnEscape={true}
        footer={footerContent}
        closable={false}
        maximized={isMobileMode}
      >
        <div className="m-0">
          {scan ? (
            <Scan
              successScan={handleSuccessScan}
              closeScan={handleCloseScan}
              isCloseOnScan={true}
            />
          ) : null}
        </div>

        <div className="mb-6 mt-12">
          <div className="p-inputgroup flex-1">
            <FloatLabel>
              <InputText
                id="userCode"
                value={cardAlias}
                onChange={(e) => setCardAlias(e.target.value)}
                keyfilter="int"
                className="text-4xl w-full"
                autoFocus
                tabIndex={0}
              />
              <label htmlFor="amount">Enter Card Number</label>
            </FloatLabel>

            <span
              className="p-inputgroup-addon cursor-pointer px-8 bg-emerald-500 border border-emerald-400"
              onClick={() => setScan(true)}
            >
              <i className="pi pi-camera text-white"></i>
            </span>
          </div>
        </div>

        {!isNil(balanceData) ? (
          <CustomerCard balanceData={balanceData} avatar={avatar} />
        ) : null}
      </Dialog>
    </div>
  );
}

export default CheckProfile;
